import { gql } from '@apollo/client'

export const GET_APPROVER_GROUPS = gql`
  query GetApproversByDeal($approverGroupsByDealRequest: ApproverGroupsByDealInput) {
    approverGroupsByDeal(input: $approverGroupsByDealRequest) {
      approverGroups {
        groupId
        groupName
        roleTitle
        decisionTypeCode
        decisionReasonCode
        isTriggerAutomatically
        isSendEmail
        approvers {
          approverType
          isActiveApprover
          approverDetails {
            approverEmail
            approverName
            approverEmployeeNumber
          }
        }
        levels
      }
    }
  }
`
